export const getScalarOpinion = (companyId: number) => `/api/dashboard/company/${companyId}`;
export const findScalarOpinion = (dashboardId: number) => `/api/dashboard/${dashboardId}`;
export const toggleValuationVisibility = (measurementDateId: number) =>
  `/api/dashboard/${measurementDateId}/toggle-valuation-visibility/`;
export const updateScalarOpinion = (companyId: number) => `/api/dashboard/${companyId}`;
export const approveReportForClient = (cmdId: number) => `/api/dashboard/company/approve-for-clients/${cmdId}`;
export const downloadFinalReportPdf = (cmdId: number) => `/api/dashboard/download-final-report-pdf/${cmdId}`;
export const getGpcCompSet = (cmdId: number) => `/api/dashboard/${cmdId}/gpc-comp-set`;
export const getCompanyRequestedInformation = (companyId: number) =>
  `/api/dashboard/company/${companyId}/requested-information`;
export const getCurrentInformationRequests = (measurementDateId: number) =>
  `/api/dashboard/current-information-requests/${measurementDateId}`;
export const modifyExistingRequest = () => '/api/dashboard/company/modify-existing-request/';
export const createRequestedDocuments = () => '/api/dashboard/company/create-requested-documents/';
export const createQuestions = () => '/api/dashboard/company/create-questions/';
export const retrieveUpdateDestroyCompanyRequestedDocument = (requestedDocumentId: number) =>
  `/api/dashboard/companies/company-requested-document/${requestedDocumentId}`;
export const retrieveUpdateDestroyCompanyQuestion = (questionId: number) =>
  `/api/dashboard/companies/company-question/${questionId}`;
export const getReportContacts = (cmdId: number) => `/api/dashboard/operations/${cmdId}/report-contacts/`;
export const draftFinalReportEmail = (cmdId: number) =>
  `/api/dashboard/operations/${cmdId}/draft-final-report-email/`;
export const searchReportBackupFiles = (cmdId: number) =>
  `/api/dashboard/operations/${cmdId}/report-files/s3-search/`;
export const listWorkboardDirectories = () =>
  '/api/dashboard/operations/report-files/workboard-directories/';
export const workboardPrefixExists = () =>
  '/api/dashboard/operations/report-files/workboard-prefix-exists/';
export const listWorkboardFiles = () =>
  '/api/dashboard/operations/report-files/workboard-files/';
export const valuationReportSelection = (valuationId: string) =>
  `/api/dashboard/operations/valuations/${valuationId}/report-selection/`;
export const startValuationExtraction = (valuationId: string) =>
  `/api/dashboard/operations/valuations/${valuationId}/extraction/`;
export const valuationExtractionStatus = (runId: string) => `/api/dashboard/operations/valuation-extraction/${runId}/`;
export const latestValuationExtractionRun = (valuationId: string) =>
  `/api/dashboard/operations/valuations/${valuationId}/extraction-runs/latest/`;

export default {
  getScalarOpinion,
  findScalarOpinion,
  toggleValuationVisibility,
  updateScalarOpinion,
  approveReportForClient,
  downloadFinalReportPdf,
  getGpcCompSet,
  getCompanyRequestedInformation,
  getCurrentInformationRequests,
  modifyExistingRequest,
  createRequestedDocuments,
  createQuestions,
  retrieveUpdateDestroyCompanyRequestedDocument,
  retrieveUpdateDestroyCompanyQuestion,
  getReportContacts,
  draftFinalReportEmail,
  searchReportBackupFiles,
  listWorkboardDirectories,
  workboardPrefixExists,
  listWorkboardFiles,
  valuationReportSelection,
  startValuationExtraction,
  valuationExtractionStatus,
  latestValuationExtractionRun,
};
